import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import styled from '@emotion/styled';
import {
  getCommentCountForFunction,
  getHasUnreadForFunction,
} from '../../store/comments/commentsSelectors';
import CommentIcon from './CommentIcon';
import CommentHoverPopover from './CommentHoverPopover';

const Button = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background-color: transparent;
  color: var(--color-white);
  cursor: pointer;
  transition: color 0.15s ease;
  &[data-state='unread'],
  &[data-state='active'] {
    color: var(--color-observations);
  }
  &:hover {
    color: var(--color-observations);
  }
`;

const CommentButton = ({ functionId, active, onClick, size = 16 }) => {
  const count = useSelector(getCommentCountForFunction(functionId));
  const unread = useSelector(getHasUnreadForFunction(functionId));
  const [hoverRect, setHoverRect] = useState(null);
  const buttonRef = useRef(null);

  const state = active ? 'active' : unread ? 'unread' : 'read';

  const handleMouseEnter = () => {
    if (buttonRef.current) setHoverRect(buttonRef.current.getBoundingClientRect());
  };

  return (
    <>
      <Button
        type="button"
        ref={buttonRef}
        data-state={state}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setHoverRect(null)}
        onClick={(e) => {
          e.stopPropagation();
          onClick && onClick(e);
        }}
        title={count > 0 ? `${count} comment${count === 1 ? '' : 's'}` : 'Add comment'}
      >
        <CommentIcon width={size} height={size} filled={state === 'unread'} />
      </Button>
      <CommentHoverPopover functionId={functionId} anchorRect={hoverRect} />
    </>
  );
};

export default CommentButton;
